import { useTranslation } from "react-i18next";
import { enUS, zhTW } from "react-day-picker/locale";

export function useDateLocale() {
  const { i18n } = useTranslation();
  return i18n.resolvedLanguage === "zh-TW" ? zhTW : enUS;
}
